export default __webpack_public_path__ + "src/images/galleries/1/entry-161096.png";